module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "marketplace-wrapper"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('v-form', {
    attrs: {
      "form": _vm.form,
      "translation": "form.products",
      "hasLabel": true
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd4be06a","hasScoped":false}!./src/app/components/marketplaceProductForm/marketplaceProductForm.html
// module id = 3116
// module chunks = 1